import { Money } from '@libs/money/money.interfaces';
import { HotelProduct, Product } from '@/api/Cart/cart.interfaces';
import { ProductPricing } from '@shared/interfaces/price';

enum PriceOperation {
    Addition,
    Subtraction,
}

function getProcessedPrice(
    price: Money,
    discount: Money,
    operation: PriceOperation
): Money | undefined {
    switch (operation) {
        case PriceOperation.Addition:
            return {
                Amount: price.Amount + discount.Amount,
                Currency: price.Currency,
            };
        case PriceOperation.Subtraction:
            return {
                Amount: price.Amount - discount.Amount,
                Currency: price.Currency,
            };
        default:
            return undefined;
    }
}

export function getProductPricing(product: Product): ProductPricing {
    const { Price, AppliedDiscount } = product;
    const isApplied = Boolean(AppliedDiscount?.IsApplied);
    const discountCode = isApplied ? AppliedDiscount?.Name : undefined;
    const discount = AppliedDiscount?.Amount ?? { Amount: 0, Currency: Price.Currency };

    const oldPrice = isApplied
        ? getProcessedPrice(Price, discount, PriceOperation.Addition)
        : undefined;

    const price = isApplied
        ? Price
        : (getProcessedPrice(Price, discount, PriceOperation.Addition) ?? Price);

    return { oldPrice: oldPrice, price: price, ...(discountCode && { discountCode }) };
}

export function getHotelRoomPricing(product: HotelProduct, amount: Money): ProductPricing {
    const { AppliedDiscount, Rooms } = product;
    const isApplied = Boolean(AppliedDiscount?.IsApplied);
    const discountCode = isApplied ? AppliedDiscount?.Name : undefined;

    const discount = {
        Amount: (AppliedDiscount?.Amount.Amount ?? 0) / (Rooms.length ?? 1),
        Currency: amount.Currency,
    };

    const oldPrice = isApplied
        ? getProcessedPrice(amount, discount, PriceOperation.Addition)
        : undefined;

    const price = isApplied
        ? amount
        : (getProcessedPrice(amount, discount, PriceOperation.Addition) ?? amount);

    return { oldPrice: oldPrice, price: price, ...(discountCode && { discountCode }) };
}
